export default "__VITE_ASSET__DPXP$gu8__"